import React, { PropsWithChildren } from 'react';
import theme from './SettingsSection.module.scss';

interface SettingsSectionContentProps extends PropsWithChildren {}

const SettingsSectionContent: React.FC<SettingsSectionContentProps> = ({ children }) => {
    return <div className={theme.content}>{children}</div>;
};

export default SettingsSectionContent;
